import PollingGraphqlContainer from './component';

export default PollingGraphqlContainer;
